<template>
  <transition name="fade">
    <!-- popup background -->
    <div v-if="isVisible" class="container-fluid">
      <div class="bb-popup-bg d-flex justify-content-center align-items-center">
        <!-- popup box -->
        <div class="card bb-card bb-popup-card mb-2 rounded" style="
            width: 24rem;
            z-index: 999999 !important;
            position: relative !important;
          ">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "PopUp",

  data: () => ({
    isVisible: false,
  }),

  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    },
  },
};
</script>